<div class="host-house-order-basic">
  <nz-spin [nzSpinning]="loading">
    <div
      class="order-container"
      [style.overflow-y]="pageType === 'sidebar' ? 'auto' : 'hidden'"
      [style.height]="pageType === 'sidebar' ? 'calc(100vh - 135px)' : 'auto'"
    >
      <!-- 模态框订单详情头部 -->
      <div class="top" *ngIf="pageType !== 'sidebar'">
        <div class="basic-info">
          <div class="left">
            <div class="picture">
              <img
                *ngIf="orderDetail?.cover_picture?.small_url"
                hostPlaceholder
                src="/assets/status/placeholder.png"
                [delaySrc]="orderDetail?.cover_picture?.small_url"
              />
            </div>
            <div class="house-detail">
              <div *ngIf="!orderDetail?.has_no_house">
                <div
                  *ngIf="
                    !orderDetail?.is_house_deleted;
                    else houseDeletedForModal
                  "
                >
                  <p class="house-title">
                    <span
                      style="cursor: pointer"
                      (click)="jumpToHouse(orderDetail?.house_id)"
                      [attr.title]="orderDetail?.house_title"
                    >
                      {{ orderDetail?.house_title || '-' }}
                    </span>
                  </p>
                  <p
                    class="house-type-title"
                    *ngIf="orderDetail?.house_type_title"
                  >
                    <span
                      style="cursor: pointer"
                      (click)="jumpToHouseType(orderDetail?.house_type_id)"
                    >
                      {{ orderDetail?.house_type_title }}
                    </span>
                  </p>
                </div>
                <ng-template #houseDeletedForModal>
                  <div class="house-deleted">
                    <span class="house-deleted-info">
                      <!-- [已删除] -->
                      {{ 'order.house_deleted' | translate }}
                    </span>
                    <span
                      class="house-deleted-title"
                      [attr.title]="orderDetail?.house_title"
                    >
                      {{ orderDetail?.house_title || '-' }}
                    </span>
                  </div>
                  <p
                    class="house-type-deleted-title"
                    *ngIf="orderDetail?.house_type_title"
                  >
                    {{ orderDetail?.house_type_title }}
                  </p>
                </ng-template>
              </div>
              <div *ngIf="orderDetail?.has_no_house">
                <div class="name">
                  <!-- 房型 {{ orderDetail?.house_type_title }} 无法排房 -->
                  {{
                    'order.house_type_contains_no_houses'
                      | translate: { houseType: orderDetail?.house_type_title }
                  }}
                </div>
                <div
                  class="error-message"
                  *ngIf="orderDetail?.out_status !== 'cancelled'"
                >
                  <!-- 房型下未包含房间，无法排房，请添加房间或移动订单 -->
                  {{ 'order.type_contains_no_house_info' | translate }}
                  <a href="javascript:void(0)" (click)="toHouseType()">
                    <!-- 添加房间 -->
                    {{ 'order.add_house' | translate }}
                  </a>
                </div>
              </div>
              <div
                *ngIf="orderDetail?.out_status === 'cancelled'"
                class="cancelled-title"
              >
                <!-- 此订单已取消，仅在订单列表可见 -->
                <p>{{ 'order.cancel_info' | translate }}</p>
              </div>
              <div *ngIf="orderDetail?.in_box" class="in-box-title">
                <img src="/assets/calendar/operator-order.png" />
                <!-- 此订单在订单盒子中 -->
                <p>
                  {{ 'order.in_orderbox_info' | translate }}
                </p>
                <a href="javascript:void(0)" (click)="toOrderbox()">
                  <!-- 查看 -->
                  {{ 'word.view' | translate }}
                </a>
              </div>
              <div
                *ngIf="
                  !orderDetail?.is_hour_reservation &&
                  !orderDetail?.in_box &&
                  (orderDetail?.status_map)['1'] &&
                  hasHouseStatus.includes(orderDetail?.out_status)
                "
              >
                <div class="house-open">
                  <div class="open-title">
                    <!-- 房态未关： -->
                    {{ 'order.house_type_not_closed' | translate }}&nbsp;
                  </div>
                  <div class="closed">
                    <div *ngFor="let status of (orderDetail?.status_map)['1']">
                      <div class="open-thirdtype">
                        <span>{{ status.platform }}</span>
                        &nbsp;&nbsp;
                      </div>
                    </div>
                    <div
                      class="close-house"
                      (click)="closeHouse()"
                      *ngIf="orderDetail?.out_status !== 'completed'"
                    >
                      <!-- 关闭房态 -->
                      {{ 'order.close_house_type' | translate }}
                    </div>
                  </div>
                </div>
              </div>
              <ng-template
                [ngTemplateOutlet]="hourOrderInfoInReservation"
                [ngTemplateOutletContext]="{ $implicit: orderDetail }"
              ></ng-template>
            </div>
          </div>
          <div
            class="right"
            *ngIf="
              !orderDetail?.is_hour_reservation &&
              hasHouseStatus.includes(orderDetail?.out_status)
            "
          >
            <a nz-dropdown [nzDropdownMenu]="menu">
              <!-- 移动订单 -->
              {{ 'order.move_order' | translate }}
              <i nz-icon nzType="down" nzTheme="outline"></i>
            </a>
            <nz-dropdown-menu #menu="nzDropdownMenu">
              <ul nz-menu nzSelectable class="menu-list">
                <li nz-menu-item (click)="orderChangeHouse()">
                  <!-- 订单换房 -->
                  <a>
                    {{ 'order.order_change_house' | translate }}
                  </a>
                </li>
                <li
                  nz-menu-item
                  *ngIf="!orderDetail?.in_box"
                  (click)="moveToOrderBox()"
                >
                  <!-- 移入订单盒子 -->
                  <a>
                    {{ 'order_dertail.move_to_orderbox' | translate }}
                  </a>
                </li>
              </ul>
            </nz-dropdown-menu>
          </div>
          <div
            class="right"
            *ngIf="
              orderDetail?.is_hour_reservation &&
              hasHouseStatus.includes(orderDetail?.out_status)
            "
          >
            <a (click)="orderChangeHouse()">{{
              'order.move_order' | translate
            }}</a>
          </div>
        </div>
        <div
          class="other-houses"
          *ngIf="orderDetail?.singleOrMass === 'mass' && !showHousesInfo"
          (click)="showHousesInfo = true"
        >
          <!-- 此订单还有{{
          orderDetail?.reservation_order?.reservation_count - 1
        }}个房间 -->
          {{
            (orderDetail?.reservation_order?.reservation_count > 2
              ? 'order.order_has_several_houses_left'
              : 'order.order_has_several_house_left'
            )
              | translate
                : {
                    count: orderDetail?.reservation_order?.reservation_count - 1
                  }
          }}
          <i nz-icon nzType="down" nzTheme="outline"></i>
        </div>
        <div
          class="hour-order-calendar"
          *ngIf="
            orderDetail?.hour_reservations?.length > 0 && hourCalendarCollapsed
          "
          (click)="expandHourCalendar()"
        >
          <!-- 展开日历 -->
          {{ 'order.expand_hour_calendar' | translate }}
          <i nz-icon nzType="down" nzTheme="outline"></i>
        </div>
      </div>

      <!-- 侧边栏订单详情头部 -->
      <div class="calendar-top" *ngIf="pageType === 'sidebar'">
        <div class="up">
          <div class="left">
            <div class="picture">
              <img
                hostPlaceholder
                src="/assets/status/placeholder.png"
                [delaySrc]="orderDetail?.cover_picture?.small_url"
              />
            </div>
            <div class="house-detail">
              <p class="house-title">
                <span
                  style="cursor: pointer"
                  (click)="jumpToHouse(orderDetail?.house_id)"
                  [attr.title]="orderDetail?.house_title"
                >
                  {{ orderDetail?.house_title || '-' }}
                </span>
              </p>
              <p class="house-type-title" *ngIf="orderDetail?.house_type_title">
                <span
                  style="cursor: pointer"
                  (click)="jumpToHouseType(orderDetail?.house_type_id)"
                >
                  {{ orderDetail?.house_type_title }}
                </span>
              </p>
            </div>
          </div>
          <div
            class="right"
            *ngIf="
              !orderDetail?.is_hour_reservation &&
              hasHouseStatus.includes(orderDetail?.out_status)
            "
          >
            <a nz-dropdown [nzDropdownMenu]="changeOrder">
              <!-- 移动订单 -->
              {{ 'order.move_order' | translate }}
              <i nz-icon nzType="down" nzTheme="outline"></i>
            </a>
            <nz-dropdown-menu #changeOrder="nzDropdownMenu">
              <ul nz-menu nzSelectable class="menu-list">
                <li nz-menu-item (click)="orderChangeHouse()">
                  <!-- 订单换房 -->
                  <a>
                    {{ 'order.order_change_house' | translate }}
                  </a>
                </li>
                <li nz-menu-item (click)="moveToOrderBox()">
                  <!-- 移入订单盒子 -->
                  <a>
                    {{ 'order_dertail.move_to_orderbox' | translate }}
                  </a>
                </li>
              </ul>
            </nz-dropdown-menu>
          </div>
          <div
            class="right"
            *ngIf="
              orderDetail?.is_hour_reservation &&
              hasHouseStatus.includes(orderDetail?.out_status)
            "
          >
            <a (click)="orderChangeHouse()">{{
              'order.move_order' | translate
            }}</a>
          </div>
        </div>
        <div *ngIf="orderDetail?.has_no_house">
          <div class="name">
            <!-- 房型 {{ orderDetail?.house_type_title }} 无法排房 -->
            {{
              'order.house_type_contains_no_houses'
                | translate: { houseType: orderDetail?.house_type_title }
            }}
          </div>
          <div
            class="error-message"
            *ngIf="orderDetail?.out_status !== 'cancelled'"
          >
            <!-- 房型下未包含房间，无法排房，请添加房间或移动订单 -->
            {{ 'order.type_contains_no_house_info' | translate }}
            <a href="javascript:void(0)" (click)="toHouseType()">
              <!-- 添加房间 -->
              {{ 'order.add_house' | translate }}
            </a>
          </div>
        </div>
        <div
          *ngIf="orderDetail?.out_status === 'cancelled'"
          class="cancelled-title"
        >
          <!-- 此订单已取消，仅在订单列表可见 -->
          <p>{{ 'order.cancel_info' | translate }}</p>
        </div>
        <div *ngIf="orderDetail?.in_box" class="in-box-title">
          <img src="/assets/calendar/operator-order.png" />
          <!-- 此订单在订单盒子中 -->
          <p>
            {{ 'order.in_orderbox_info' | translate }}
          </p>
          <a href="javascript:void(0)" (click)="toOrderbox()">
            <!-- 查看 -->
            {{ 'word.view' | translate }}
          </a>
        </div>
        <div
          *ngIf="
            !orderDetail?.is_hour_reservation &&
            !orderDetail?.in_box &&
            (orderDetail?.status_map)['1'] &&
            hasHouseStatus.includes(orderDetail?.out_status)
          "
        >
          <div class="house-open">
            <div class="open-title">
              <!-- 房态未关： -->
              {{ 'order.house_type_not_closed' | translate }}&nbsp;
            </div>
            <div class="closed" [style.width]="'310px'">
              <div *ngFor="let status of (orderDetail?.status_map)['1']">
                <div class="open-thirdtype">
                  <span>
                    {{ 'word.channel_' + status.thirdparty_type | translate }}
                  </span>
                  &nbsp;&nbsp;
                </div>
              </div>
              <div
                class="close-house"
                (click)="closeHouse()"
                *ngIf="orderDetail?.out_status !== 'completed'"
              >
                <!-- 关闭房态 -->
                {{ 'order.close_house_type' | translate }}
              </div>
            </div>
          </div>
        </div>
        <ng-template
          [ngTemplateOutlet]="hourOrderInfoInReservation"
          [ngTemplateOutletContext]="{ $implicit: orderDetail }"
        ></ng-template>
        <div
          class="other-houses"
          *ngIf="orderDetail?.singleOrMass === 'mass' && !showHousesInfo"
          (click)="showHousesInfo = true"
        >
          <!-- 此订单还有{{
        orderDetail?.reservation_order?.reservation_count - 1
      }}个房间 -->
          {{
            (orderDetail?.reservation_order?.reservation_count > 2
              ? 'order.order_has_several_houses_left'
              : 'order.order_has_several_house_left'
            )
              | translate
                : {
                    count: orderDetail?.reservation_order?.reservation_count - 1
                  }
          }}
          <i nz-icon nzType="down" nzTheme="outline"></i>
        </div>
        <div
          class="hour-order-calendar"
          *ngIf="
            orderDetail?.hour_reservations?.length > 0 && hourCalendarCollapsed
          "
          (click)="expandHourCalendar()"
        >
          <!-- 展开日历 -->
          {{ 'order.expand_hour_calendar' | translate }}
          <i nz-icon nzType="down" nzTheme="outline"></i>
        </div>
      </div>

      <!-- 多入住单房间列表展开 -->
      <div class="house-list" *ngIf="showHousesInfo">
        <div class="houses">
          <div class="house" *ngFor="let order of reservationList">
            <div class="house-left">
              <div class="picture">
                <img
                  hostPlaceholder
                  [delaySrc]="order?.picture"
                  src="/assets/status/placeholder.png"
                  [attr.data-src]="order?.picture"
                />
              </div>
              <div class="house-detail">
                <p class="house-title">{{ order?.title }}</p>
                <div class="house-type-title">
                  <div
                    *ngIf="order?.house_type_title"
                    class="type-name"
                    [attr.title]="order?.house_type_title"
                  >
                    {{ order?.house_type_title }}
                  </div>
                  <span class="time-bar" *ngIf="order?.house_type_title">
                    |
                  </span>
                  <span>
                    {{ order?.check_in | dateformat: ['MD'] }} ~
                    {{ order?.check_out | dateformat: ['MD'] }}
                  </span>
                </div>
              </div>
            </div>
            <div class="house-middle">
              <span>
                {{ order?.currency | currencyToSymbol }}
              </span>
              <span>{{ order?.house_fee }}</span>
              <span class="amount-bar">|</span>
              <span>
                {{ 'order_status.' + order?.out_status | translate }}
              </span>
            </div>
            <button
              nz-button
              class="house-right"
              (click)="checkReservation(order?.code)"
            >
              <!-- 查看 -->
              {{ 'word.view' | translate }}
            </button>
          </div>
        </div>
        <div class="collapse" (click)="showHousesInfo = false">
          <!-- 收起 -->
          {{ 'word.shut' | translate }}
          <i nz-icon nzType="up" nzTheme="outline"></i>
        </div>
      </div>

      <!-- 小时单日历 -->
      <div
        class="hour-calendar"
        *ngIf="
          orderDetail?.hour_reservations.length > 0 &&
          !hourCalendarCollapsed &&
          orderDetail?.is_hour_reservation
        "
      >
        <host-hour-room-calendar
          [listOfOrder]="orderDetail?.hour_reservations"
          [checkinReservation]="orderDetail?.checkin_reservation"
          [checkoutReservation]="orderDetail?.checkout_reservation"
          [currentReservation]="orderDetail?.code"
          (onDoubleClick)="createNewHourOrder()"
          (onReservationClick)="JumptoHourDetail($event)"
        ></host-hour-room-calendar>
        <div class="collapse" (click)="collapseHourCalendar()">
          <!-- 收起日历 -->
          {{ 'order.collapse_hour_calendar' | translate }}
          <i nz-icon nzType="up" nzTheme="outline"></i>
        </div>
      </div>

      <div class="container">
        <!-- 订单标签 -->
        <div class="tags">
          <div *ngIf="isConflict" class="conflict">
            <p class="conflict-text">
              <!-- 冲突订单 -->
              {{ 'order.conflict_order' | translate }}
            </p>
          </div>

          <host-add-label-picker
            [(ngModel)]="currentTags"
            [listOfLabel]="listOfTag"
            (ngModelChange)="onTagsChange($event)"></host-add-label-picker>

          <!-- <div *ngFor="let tag of tags">
            <div *ngIf="tag.id !== 1" class="tag">
              <div class="tag-title" [style.background]="tag.color">
                {{ tag.tag_name }}
              </div>
              <img
                src="/assets/status/cancel-label.png"
                class="delete"
                [style.background]="tag.color"
                (click)="deleteTag(tag)"
              />
            </div>
          </div>
          <div class="add-tag" (click)="checkTag($event)" #tagModal>
            <i nz-icon nzType="plus" nzTheme="outline"></i>
            <p>{{ 'order.add_tag' | translate }}</p>
          </div> -->
        </div>

        <div class="mt-10 danger-link-text" *ngIf="isConflict" (click)="onClickConflictLink()">
          {{ "reservation.detail.op.view_conflict" | translate }} >
          <!-- 查看冲突单 > -->
        </div>

        <form nz-form [formGroup]="form">
          <!-- 入住信息 -->
          <div class="form-title">
            <h1>{{ 'order.check_in_info' | translate }}</h1>
            <div class="edit" (click)="editOrderInfo()" *ngIf="showOrderInfo">
              {{ 'word.modify' | translate }}
            </div>
            <div class="edit-result" *ngIf="!showOrderInfo">
              <div (click)="cancelEditOrderInfo()">
                {{ 'word.cancel' | translate }}
              </div>
              <div (click)="confirmEditOrderInfo()">
                {{ 'word.save' | translate }}
              </div>
            </div>
          </div>
          <ul [ngClass]="showOrderInfo ? 'show-ul' : 'edit-ul'">
            <!-- 状态 -->
            <li class="width w-110">
              <label>{{ 'order.status' | translate }}</label>
            </li>
            <li class="width w-310">
              <div class="order-status">
                <div
                  [ngClass]="{
                    status: hasHouseStatus.includes(orderDetail?.out_status),
                    common: !hasHouseStatus.includes(orderDetail?.out_status)
                  }"
                  [style.background]="orderDetail?.statusBackground"
                >
                  {{ 'order_status.' + orderDetail?.out_status | translate }}
                </div>
                <div
                  class="operation"
                  (click)="revocation(0)"
                  *ngIf="orderDetail?.handle_status === 'revoke_check_in'"
                >
                  <!-- 撤销入住 -->
                  {{ 'order.cancel_check_in' | translate }}
                </div>
                <div
                  class="operation"
                  (click)="revocation(0)"
                  *ngIf="orderDetail?.handle_status === 'revoke_check_out'"
                >
                  <!-- 撤销退房 -->
                  {{ 'order.cancel_check_out' | translate }}
                </div>
              </div>
            </li>
            <!-- 入离 -->
            <li class="width w-110">
              <label>
                {{ 'order.check_in_and_out_date' | translate }}
              </label>
            </li>
            <li class="width w-310">
              <div
                class="row"
                *ngIf="showOrderInfo && !orderDetail?.is_hour_reservation"
              >
                <span>
                  {{ orderDetail?.check_in | dateformat: ['MD'] }} ~
                  {{ orderDetail?.check_out | dateformat: ['MD'] }}
                </span>
                <span style="padding-left: 5px">
                  {{ showTotalNights }}
                  {{
                    (showTotalNights > 1 ? 'word.nights' : 'word.night')
                      | translate
                  }}
                </span>
              </div>
              <div
                class="row"
                *ngIf="showOrderInfo && orderDetail?.is_hour_reservation"
              >
                <span>
                  {{ orderDetail?.check_in | dateformat: ['MD'] }}
                </span>
                <span style="padding-left: 5px">
                  {{
                    orderDetail?.hourOrderStartTime | dateformat: [null, 'hm']
                  }}~{{
                    orderDetail?.hourOrderEndTime | dateformat: [null, 'hm']
                  }}
                </span>
                <span style="padding-left: 5px">
                  {{
                    (orderDetail?.diffHour > 1
                      ? 'order.hour_order_total_hours'
                      : 'order.hour_order_total_hour'
                    )
                      | translate
                        : { hour: orderDetail?.diffHour | number: '1.0-1' }
                  }}
                </span>
              </div>
              <div
                class="row"
                *ngIf="!showOrderInfo && !orderDetail?.is_hour_reservation"
              >
                <nz-form-item>
                  <nz-form-control>
                    <nz-range-picker
                      [nzFormat]="angularDateFormat"
                      formControlName="date"
                    ></nz-range-picker>
                  </nz-form-control>
                </nz-form-item>
                <span style="padding-left: 5px">
                  {{ total_nights }}
                  {{
                    (getDays(form.get('date').value) > 1
                      ? 'word.nights'
                      : 'word.night'
                    ) | translate
                  }}
                </span>
              </div>
              <div
                class="row"
                *ngIf="!showOrderInfo && orderDetail?.is_hour_reservation"
              >
                <nz-form-item>
                  <nz-form-control>
                    <nz-date-picker formControlName="date"></nz-date-picker>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </li>
            <!-- 来源 -->
            <li class="width w-110">
              <label>{{ 'order.origin' | translate }}</label>
            </li>
            <li class="width w-310">
              <div
                *ngIf="showOrderInfo || orderDetail?.thirdparty_type !== 5"
                class="row"
                style="flex-flow: row wrap"
              >
                <div *ngIf="orderDetail?.has_changed" class="row">
                  <span>{{ 'order.change_house' | translate }}-</span>
                  <!-- <span *ngIf="orderDetail?.thirdparty_type !== 5">
                    {{
                      "word.channel_" + orderDetail?.thirdparty_type | translate
                    }}
                  </span> -->
                </div>
                <div class="row" *ngIf="orderDetail?.thirdparty_type === 5">
                  <span>
                    <!-- 手工单 -->
                    {{ 'order.handmade_order' | translate }}
                  </span>
                  <span>
                    -{{ getHandMadeChannel(orderDetail?.handmade_chanel) }}
                  </span>

                </div>
                <div class="row" *ngIf="orderDetail?.thirdparty_type !== 5">
                  <span>
                    {{
                      'word.channel_' + orderDetail?.thirdparty_type | translate
                    }}
                  </span>
                  <!-- <span *ngIf="orderDetail?.thirdparty_username !== ''"
                    >-{{ orderDetail?.thirdparty_username }}</span
                  > -->
                </div>
              </div>
              <div
                class="row"
                *ngIf="!showOrderInfo && orderDetail?.thirdparty_type === 5"
              >
                <nz-select
                  formControlName="channel"
                  style="width: 272px; height: 32px"
                >
                  <nz-option
                    *ngFor="let item of leavedChannelOptions"
                    [nzValue]="item.code"
                    [nzLabel]="item.channel_name"
                  ></nz-option>
                </nz-select>
              </div>
            </li>
            <!-- 初始房间 -->
            <li
              class="width w-110"
              *ngIf="
                orderDetail?.has_changed &&
                orderDetail?.old_house &&
                orderDetail?.old_house !== ''
              "
            >
              <label>{{ 'order.origin_house' | translate }}</label>
            </li>
            <li
              class="width w-310"
              *ngIf="
                orderDetail?.has_changed &&
                orderDetail?.old_house &&
                orderDetail?.old_house !== ''
              "
            >
              <span [attr.title]="orderDetail?.old_house">
                {{ orderDetail?.old_house | ellipsis: 20 }}
              </span>
            </li>
            <!-- 房客 -->
            <li class="width w-110">
              <label>{{ 'order.tenant' | translate }}</label>
            </li>
            <li class="width w-310">
              <div
                class="row"
                *ngIf="showOrderInfo"
              >
                <span style="max-width: 175px">{{
                  orderDetail?.client?.name
                }}</span>
                <span>
                  <span [innerHTML]="'word.open_parenthesis' | translate"></span
                  >{{ orderDetail?.number_of_guests || '1' }}
                  {{
                    (orderDetail?.number_of_guests > 1
                      ? 'word.total_people'
                      : 'word.total_person'
                    ) | translate
                  }}<span
                    [innerHTML]="'word.close_parenthesis' | translate"
                  ></span>
                </span>
                <div
                  class="dialogue"
                  style="margin-left: 12px"
                  *ngIf="
                    orderDetail?.thread_id && orderDetail?.thirdparty_type !== 5
                  "
                  (click)="toDialogueList()"
                >
                  {{ 'order.chat' | translate }}
                </div>
              </div>
              <div
                class="row"
                *ngIf="!showOrderInfo"
              >
                <nz-form-item>
                  <nz-form-control>
                    <input
                      nz-input
                      formControlName="name"
                      placeholder="{{ 'order.tenant_name' | translate }}"
                      class="width w-150"
                    />
                    <span>
                      <nz-input-number
                        formControlName="personCount"
                        [nzMin]="0"
                        [nzMax]="99"
                        [nzStep]="1"
                        class="width w-90"
                        style="margin-left: 10px"
                      >
                      </nz-input-number>
                      {{
                        (form.get('personCount').value > 1
                          ? 'word.total_people'
                          : 'word.total_person'
                        ) | translate
                      }}
                    </span>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </li>
            <!-- 手机 -->
            <li class="width w-110">
              <label>{{ 'order.phone' | translate }}</label>
            </li>
            <li class="width w-310">
              <div *ngIf="showOrderInfo" class="row">
                <span *ngIf=" orderDetail?.client?.phone else emptyMobile">{{ orderDetail?.client?.phone }}</span>
                <ng-template #emptyMobile>
                  <span>{{ 'order.no_mobile' | translate }}</span>
                </ng-template>
              </div>
              <div *ngIf="!showOrderInfo" class="row">
                <nz-form-item>
                  <nz-form-control>
                    <input
                      nz-input
                      hostInputNumber
                      formControlName="mobile"
                      maxlength="13"
                      placeholder="{{
                        'placeholder.mobile_optional' | translate
                      }}"
                      class="width w-272"
                    />
                  </nz-form-control>
                </nz-form-item>
              </div>
            </li>
            <!-- 邮箱 -->
            <li
              class="width w-110"
              *ngIf="
                orderDetail?.thirdparty_type === 0 &&
                orderDetail?.booking_info?.email
              "
            >
              <label>{{ 'order.email' | translate }}</label>
            </li>
            <li
              class="width w-310"
              *ngIf="
                orderDetail?.thirdparty_type === 0 &&
                orderDetail?.booking_info?.email
              "
            >
              <span>{{ orderDetail?.booking_info?.email }}</span>
            </li>
            <!-- 附言 -->
            <ng-container *ngIf="
                  (orderDetail?.thirdparty_type === Platform.ZHENGUO ||
                  orderDetail?.thirdparty_type === Platform.MUNIAO ||
                  orderDetail?.thirdparty_type === Platform.BOOKING) && orderDetail?.remark
                ">
              <li class="width w-110">
                <label>{{ 'order.remark' | translate }}</label>
              </li>
              <li class="width w-310">
                <span *ngIf="orderDetail?.remark"
                      style="flex-shrink: 0; width: 260px; white-space: nowrap; overflow: hidden; text-overflow:
                      ellipsis">{{
                  orderDetail?.remark }}</span>
                <span *ngIf="!orderDetail?.remark">
                  {{ 'word.none' | translate }}
                </span>
                <span
                  class="more"
                  style="margin-left: 10px;border: 1px solid #ddd; border-radius: 4px; font-size: 12px; color:
                  #a2a2a2; padding: 0 5px; cursor: pointer"
                  nz-popover
                  [nzPopoverTitle]="null"
                  [nzPopoverContent]="remarkPop">{{ "word.more" | translate }}
                </span>
                <ng-template #remarkPop>
                  <div
                    style="color: #666; max-width: 500px"
                    [innerHTML]="orderDetail.remark.replaceAll('\n', '<br>') | html"></div>
                </ng-template>
              </li>
            </ng-container>
            <ng-container *ngIf="orderDetail?.comment">
              <li class="width w-110">
                <label>{{ 'rate.word.rate' | translate }}</label>
              </li>
              <li class="width w-310">
                <div>
                  <span style="margin-right: 10px">{{
                    orderDetail?.comment?.guest_comment_desc
                  }}</span>
                  <a
                    href="javascript:void(0)"
                    (click)="toRateDetail()"
                    style="color: #2c80f0"
                    >{{ 'order.detail' | translate }}</a
                  >
                </div>
              </li>
            </ng-container>
            <!-- 入住号 -->
            <li class="width w-110 align-top">
              <label>
                {{ 'order.check_in_order_code' | translate }}
              </label>
            </li>
            <li class="width w-310">
              <div class="order-code">
                <span style="max-width: 200px; word-break: break-all">
                  {{ orderDetail?.code }}
                </span>
                <div
                  class="checkin-copy"
                  hostClipboard
                  [clipboardData]="orderDetail?.code">
                  <!-- 复制 -->
                  {{ 'word.copy' | translate }}
                </div>
                <div
                  class="checkin-copy"
                  style="margin-left: 10px"
                  (click)="toLog('reservation', orderDetail?.code)"
                >
                  <!-- 日志 -->
                  {{ 'system.log' | translate }}
                </div>
              </div>
            </li>
          </ul>

          <!-- 费用 -->
          <div class="form-title">
            <div class="row">
              <h1
                [style.width]="
                  !showOrderAmount && orderDetail?.thirdparty_type === 5
                    ? '48px'
                    : 'auto'
                "
              >
                <!-- 费用 -->
                {{ 'word.fee' | translate }}
              </h1>

              <nz-select
                *ngIf="
                  !showOrderAmount && orderDetail?.thirdparty_type === 5;
                  else showCurrencyType
                "
                formControlName="currency"
                (ngModelChange)="currencyChange()"
              >
                <nz-option
                  *ngFor="let opt of currencyList"
                  [nzLabel]="opt"
                  [nzValue]="opt"
                ></nz-option>
              </nz-select>
              <ng-template #showCurrencyType>
                <h1>
                  <span [innerHTML]="'word.open_parenthesis' | translate"></span
                  >{{ orderDetail?.currency_type }}
                  {{ orderDetail?.currency_type | currencyToSymbol
                  }}<span
                    [innerHTML]="'word.close_parenthesis' | translate"
                  ></span>
                </h1>
              </ng-template>
            </div>
            <div class="row">
              <div class="edit" (click)="addFinance()" *ngIf="showOrderAmount">
                <!-- 记账 -->
                {{ 'word.add_note' | translate }}
              </div>
              <div
                class="edit"
                style="padding-left: 10px"
                (click)="onModifyOrderFee()"
                *ngIf="showOrderAmount"
              >
                {{ 'word.modify' | translate }}
              </div>
              <div class="edit-result" *ngIf="!showOrderAmount">
                <div (click)="cancelEditOrderAmount()">
                  {{ 'word.cancel' | translate }}
                </div>
                <div (click)="onConfirmModifyOrderFee()">
                  {{ 'word.save' | translate }}
                </div>
              </div>
            </div>
          </div>
          <ul [ngClass]="showOrderAmount ? 'show-ul' : 'edit-ul'">
            <li class="width w-110">
              <!-- 房费： -->
              <label>
                {{ 'order.detail_house_fee' | translate }}
              </label>
            </li>
            <li class="width w-310" style="max-height: 120px">
              <div class="fee-detail row">
                <span>
                  {{ orderDetail?.currency_type | currencyToSymbol }}
                </span>
                <span *ngIf="showOrderAmount">
                  {{ orderDetail?.amount_items?.house_fee?.amount }}
                </span>
                <span *ngIf="!showOrderAmount">
                  <nz-form-item style="margin-right: 5px">
                    <nz-form-control>
                      <div class="number-input">
                        <host-input-with-error
                          [showError]="
                            checkingExtensionHouseFee &&
                            (form.get('house_price').value === '' ||
                              (orderDetail?.onlineExtended &&
                                form.get('house_price').value <
                                  orderDetail?.amount_items?.online_house_fee
                                    ?.amount))
                          "
                          [errorText]="
                            form.get('house_price').value === ''
                              ? houseFeeEmptyErrorText
                              : editExtensionHouseFeeErrorText
                          "
                        >
                          <nz-input-number
                            formControlName="house_price"
                            [nzMin]="0"
                            [nzMax]="maxAmount"
                            [nzStep]="1"
                            [nzPrecision]="2"
                            class="width w-150"
                            nzPlaceHolder="{{
                              'placeholder.fee_required' | translate
                            }}"
                            (nzFocus)="foucusHousePrice()"
                          ></nz-input-number>
                        </host-input-with-error>
                      </div>
                    </nz-form-control>
                  </nz-form-item>
                </span>
                <span [innerHTML]="'word.open_parenthesis' | translate"></span>
                <div *ngIf="orderDetail?.settled === 1">
                  <div
                    *ngIf="
                      orderDetail?.amount_items?.arrearage_status?.status === 1
                    "
                    class="row"
                  >
                    <div *ngIf="orderDetail?.singleOrMass === 'mass'">
                      {{
                        'order.detail_total_fee'
                          | translate
                            : {
                                currencySymbol: currencySymbol,
                                amount:
                                  orderDetail?.amount_items?.order_house_fee
                                    ?.amount
                              }
                      }},&nbsp;
                    </div>
                    <!-- 未付 -->
                    {{ 'order.unpaid' | translate }}
                  </div>
                  <div
                    *ngIf="
                      orderDetail?.amount_items?.arrearage_status?.status === 2
                    "
                    class="row"
                  >
                    <div *ngIf="orderDetail?.singleOrMass === 'mass'">
                      {{
                        'order.detail_total_fee'
                          | translate
                            : {
                                currencySymbol: currencySymbol,
                                amount:
                                  orderDetail?.amount_items?.order_house_fee
                                    ?.amount
                              }
                      }},&nbsp;
                    </div>
                    <!-- 欠 -->
                    {{ 'order.owe_a_fee' | translate }}
                    {{ orderDetail?.currency_type | currencyToSymbol
                    }}{{ orderDetail?.paid_amount }}
                  </div>
                </div>
                <div *ngIf="orderDetail?.settled === 2" class="row">
                  <div *ngIf="orderDetail?.singleOrMass === 'mass'">
                    {{
                      'order.detail_total_fee'
                        | translate
                          : {
                              currencySymbol: currencySymbol,
                              amount:
                                orderDetail?.amount_items?.order_house_fee
                                  ?.amount
                            }
                    }},&nbsp;
                  </div>
                  <!-- 多付 -->
                  {{ 'order.overpayment' | translate }}
                  {{ orderDetail?.currency_type | currencyToSymbol
                  }}{{ orderDetail?.paid_amount }}
                </div>
                <div *ngIf="orderDetail?.settled === 0" class="row">
                  <div *ngIf="orderDetail?.singleOrMass === 'mass'">
                    {{
                      'order.detail_total_fee'
                        | translate
                          : {
                              currencySymbol: currencySymbol,
                              amount:
                                orderDetail?.amount_items?.order_house_fee
                                  ?.amount
                            }
                    }},&nbsp;
                  </div>
                  <!-- 已结清 -->
                  {{ 'order.money_cleared' | translate }}
                </div>
                <span [innerHTML]="'word.close_parenthesis' | translate"></span>

                <div
                  *ngIf="orderDetail?.price_list?.length"
                  class="row label-btn"
                  nz-popover
                  [nzPopoverTitle]="feeTitle"
                  [nzPopoverContent]="feeContent"
                >
                  {{ 'order_detail.pop.btn.fee_detail.title' | translate }}
                </div>
                <ng-template #feeTitle>
                  {{ 'order_detail.pop.fee_detail.title' | translate }}
                </ng-template>
                <ng-template #feeContent>
                  <div
                    class="pop-fee-content"
                    style="display: flex; flex-direction: row; color: #111112"
                  >
                    <div
                      class="pf-item"
                      style="margin-right: 20px"
                      *ngFor="let price of orderDetail?.price_list"
                    >
                      {{ price.title }}：{{ price.currency | currencyToSymbol }}
                      {{ price.amount }}
                    </div>
                  </div>
                </ng-template>
              </div>
            </li>
            <li
              class="width w-110"
              *ngIf="
                orderDetail?.amount_items?.extension_house_fee &&
                pageType === 'sidebar'
              "
            >
              <label *ngIf="orderDetail?.singleOrMass === 'single'">
                <!-- 佣金： -->
                {{ 'order.commission' | translate }}
              </label>
              <label *ngIf="orderDetail?.singleOrMass === 'mass'">
                <!-- 总佣金： -->
                {{ 'order.order_commission' | translate }}
              </label>
            </li>
            <li
              class="width w-310"
              *ngIf="
                orderDetail?.amount_items?.extension_house_fee &&
                pageType === 'sidebar'
              "
            >
              <div class="row fee-detail">
                <span>
                  {{ orderDetail?.currency_type | currencyToSymbol }}
                </span>
                <span
                  *ngIf="
                    showOrderAmount ||
                    (!showOrderAmount && orderDetail?.thirdparty_type !== 5)
                  "
                >
                  {{ orderDetail?.amount_items?.commission?.amount }}
                </span>
                <span
                  *ngIf="!showOrderAmount && orderDetail?.thirdparty_type === 5"
                >
                  <nz-form-item>
                    <nz-form-control>
                      <div class="number-input" style="padding-right: 5px">
                        <nz-input-number
                          formControlName="commission"
                          [nzMin]="0"
                          [nzMax]="maxAmount"
                          [nzStep]="1"
                          [nzPrecision]="2"
                          class="width w-150"
                          nzPlaceHolder="{{
                            'placeholder.fee_required' | translate
                          }}"
                        ></nz-input-number>
                      </div>
                    </nz-form-control>
                  </nz-form-item>
                </span>
                <span [innerHTML]="'word.open_parenthesis' | translate"></span>
                <div class="row">
                  <!-- 净房费 -->
                  <!-- 总净房费 -->
                  {{
                    (orderDetail?.singleOrMass === 'single'
                      ? 'order.net_fee'
                      : 'order.order_net_fee'
                    ) | translate
                  }}
                  &nbsp;
                  <div>
                    {{ orderDetail?.currency_type | currencyToSymbol }}
                  </div>
                  {{
                    orderDetail?.singleOrMass === 'single'
                      ? orderDetail?.amount_items?.net_house_fee?.amount
                      : orderDetail?.amount_items?.order_net_house_fee?.amount
                  }}
                </div>
                <span [innerHTML]="'word.close_parenthesis' | translate"></span>
              </div>
            </li>
            <li
              class="width w-110"
              *ngIf="orderDetail?.amount_items?.other_income?.amount !== 0"
            >
              <label>
                <!-- 其他收入： -->
                {{ 'order.other_income' | translate }}
              </label>
            </li>
            <li
              class="width w-310"
              *ngIf="orderDetail?.amount_items?.other_income.amount !== 0"
            >
              <div class="row fee-detail">
                <div>
                  {{ orderDetail?.currency_type | currencyToSymbol }}
                </div>
                <div>
                  {{ orderDetail?.amount_items?.other_income?.amount }}
                </div>
              </div>
            </li>
            <li
              class="width w-110"
              *ngIf="
                orderDetail?.amount_items?.other_income?.amount === 0 &&
                pageType === 'modal'
              "
            ></li>
            <li
              class="width w-310"
              *ngIf="
                orderDetail?.amount_items?.other_income?.amount === 0 &&
                pageType === 'modal'
              "
            ></li>
            <li
              class="width w-110"
              *ngIf="
                orderDetail?.amount_items?.extension_house_fee &&
                pageType === 'modal'
              "
            >
              <label *ngIf="orderDetail?.singleOrMass === 'single'">
                <!-- 佣金： -->
                {{ 'order.commission' | translate }}
              </label>
              <label *ngIf="orderDetail?.singleOrMass === 'mass'">
                <!-- 总佣金： -->
                {{ 'order.order_commission' | translate }}
              </label>
            </li>
            <li
              class="width w-310"
              *ngIf="
                orderDetail?.amount_items?.extension_house_fee &&
                pageType !== 'sidebar'
              "
            >
              <div class="row fee-detail">
                <span>
                  {{ orderDetail?.currency_type | currencyToSymbol }}
                </span>
                <span
                  *ngIf="
                    showOrderAmount ||
                    (!showOrderAmount && orderDetail?.thirdparty_type !== 5)
                  "
                >
                  {{ orderDetail?.amount_items?.commission?.amount }}
                </span>
                <span
                  *ngIf="!showOrderAmount && orderDetail?.thirdparty_type === 5"
                >
                  <nz-form-item>
                    <nz-form-control>
                      <div class="number-input" style="padding-right: 5px">
                        <nz-input-number
                          formControlName="commission"
                          [nzMin]="0"
                          [nzMax]="maxAmount"
                          [nzStep]="1"
                          [nzPrecision]="2"
                          class="width w-150"
                          nzPlaceHolder="{{
                            'placeholder.fee_required' | translate
                          }}"
                        ></nz-input-number>
                      </div>
                    </nz-form-control>
                  </nz-form-item>
                </span>
                <span [innerHTML]="'word.open_parenthesis' | translate"></span>
                <div class="row">
                  <!-- 净房费 -->
                  <!-- 总净房费 -->
                  {{
                    (orderDetail?.singleOrMass === 'single'
                      ? 'order.net_fee'
                      : 'order.order_net_fee'
                    ) | translate
                  }}
                  &nbsp;
                  <div>
                    {{ orderDetail?.currency_type | currencyToSymbol }}
                  </div>
                  {{
                    orderDetail?.singleOrMass === 'single'
                      ? orderDetail?.amount_items?.net_house_fee?.amount
                      : orderDetail?.amount_items?.order_net_house_fee?.amount
                  }}
                </div>
                <span [innerHTML]="'word.close_parenthesis' | translate"></span>
              </div>
            </li>
            <li
              class="width w-110"
              *ngIf="orderDetail?.amount_items?.expense.amount !== 0"
            >
              <!-- 支出： -->
              <label>{{ 'order.outcome' | translate }}</label>
            </li>
            <li
              class="width w-310"
              *ngIf="orderDetail?.amount_items?.expense.amount !== 0"
            >
              <div class="row fee-detail">
                <div>
                  {{ orderDetail?.currency_type | currencyToSymbol }}
                </div>
                <div>
                  {{ orderDetail?.amount_items?.expense?.amount }}
                </div>
              </div>
            </li>
          </ul>

          <!-- 入住管理 -->
          <div class="form-title" #checkinAndOut>
            <h1>{{ 'order.check_in_noun' | translate }}</h1>

            <div>
              <a 
                class="edit" 
                style="margin-right: 10px;" 
                routerLink="/app/properties/detail" 
                [queryParams]="{id: orderDetail?.house_id, title: orderDetail?.house_title}">{{ "word.set" | translate }}
              </a>

              <host-widget-check-guide-menu
                [houseId]="orderDetail?.house_id"
                [code]="orderDetail?.code"
                [completeCheckGuideSetting]="orderDetail?.house_checkin_setting"></host-widget-check-guide-menu>
            </div>
          </div>
          <ul class="edit-ul">
            <li class="width w-110">
              <!-- 到店时间： -->
              <label>
                {{ 'order.check_in_time_1' | translate }}
              </label>
            </li>
            <li class="width w-310">
              <div class="row">
                <nz-form-item>
                  <nz-form-control>
                    <span>
                      {{ orderDetail?.check_in | dateformat: ['MD'] }}
                    </span>
                    <nz-time-picker
                      #checkinPicker
                      style="margin-left: 10px; width: 150px"
                      [nzFormat]="timeFormat"
                      nzPopupClassName="order-detail-check-time-picker"
                      formControlName="inTime"
                      [(nzOpen)]="checkInOPen"
                      [nzAddOn]="addOnCheckInTemplate"
                      [nzAllowEmpty]="false"
                      [nzUse12Hours]="use12Hours"
                      (click)="editInAndOut('checkin', checkinAndOut)"
                    ></nz-time-picker>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </li>
            <li class="width w-110">
              <!-- 退房时间： -->
              <label>
                {{ 'order.check_out_time_1' | translate }}
              </label>
            </li>
            <li class="width w-310">
              <div class="row">
                <nz-form-item>
                  <nz-form-control>
                    <span>
                      {{ orderDetail?.check_out | dateformat: ['MD'] }}
                    </span>
                    <nz-time-picker
                      #checkoutPicker
                      style="margin-left: 10px; width: 150px"
                      [nzFormat]="timeFormat"
                      nzPopupClassName="order-detail-check-time-picker"
                      formControlName="outTime"
                      [(nzOpen)]="checkOutOPen"
                      [nzAddOn]="addOnCheckOutTemplate"
                      [nzAllowEmpty]="false"
                      [nzUse12Hours]="use12Hours"
                      (click)="editInAndOut('checkout', checkinAndOut)"
                    ></nz-time-picker>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </li>
            <li
              class="width w-110"
              *ngIf="
                showGuideInfo &&
                orderDetail?.guide_info?.lock?.lock_status !== -1
              "
            >
              <!-- 门锁密码： -->
              <label>
                {{ 'order.lock_password' | translate }}
              </label>
            </li>
            <li
              class="width w-310"
              *ngIf="
                showGuideInfo &&
                orderDetail?.guide_info?.lock?.lock_status !== -1
              "
            >
              <div class="row">
                <nz-form-item>
                  <nz-form-control>
                    <div *ngIf="!fillInPasswordManually">
                      <span
                        *ngIf="orderDetail?.guide_info?.lock?.lock_password === null"
                      >
                        <!-- 未设置 -->
                        {{ 'order.lock_unset' | translate }}
                      </span>
                      <span
                        *ngIf="orderDetail?.guide_info?.lock?.lock_password"
                      >
                        {{ orderDetail?.guide_info?.lock?.lock_password }}
                      </span>
                      <a
                        nz-dropdown
                        [nzDropdownMenu]="lockSetting"
                        class="operating"
                      >
                        <!-- 设置 -->
                        {{ 'word.set_lock_pwd' | translate }}
                      </a>
                      <nz-dropdown-menu #lockSetting="nzDropdownMenu">
                        <ul nz-menu nzSelectable class="menu-list">
                          <li
                            nz-menu-item
                            *ngIf="
                              orderDetail?.guide_info?.lock?.lock_status === 0
                            "
                            (click)="manuallyFillIn()"
                          >
                            <!-- 手动填写 -->
                            {{ 'order.input_lock_manually' | translate }}
                          </li>
                          <li
                            nz-menu-item
                            *ngIf="orderDetail?.guide_info?.lock?.lock_status === 0"
                            (click)="jumpToRoomCheckinDetail(orderDetail?.house_id)"
                          >
                            <!-- 房间入住设置 -->
                            {{ 'order.room_checkin_setting' | translate }}
                          </li>
                          <li
                            nz-menu-item
                            *ngIf="orderDetail?.guide_info?.lock?.lock_status === 1"
                            (click)="createPassword()"
                          >
                            <!-- 现在生成 -->
                            {{ 'order.now_create' | translate }}
                          </li>
                          <li
                            nz-menu-item
                            *ngIf="orderDetail?.guide_info?.lock?.lock_status === 1"
                            (click)="manuallyFillIn()"
                          >
                            <!-- 手动填写 -->
                            {{ 'order.input_lock_manually' | translate }}
                          </li>
                          <li
                            nz-menu-item
                            *ngIf="
                              orderDetail?.guide_info?.lock?.lock_status === 2
                            "
                            (click)="deletePassword()"
                          >
                            <!-- 删除密码 -->
                            {{ 'order.delete_password' | translate }}
                          </li>
                        </ul>
                      </nz-dropdown-menu>
                    </div>
                    <div *ngIf="fillInPasswordManually">
                      <div class="row">
                        <input
                          type="text"
                          nz-input
                          formControlName="password"
                          class="width w-150 input-password"
                        />
                        <div class="edit-result" style="margin-left: 10px">
                          <div (click)="cancelEditLockPassword()">
                            {{ 'word.cancel' | translate }}
                          </div>
                          <div (click)="saveLockPassword()">
                            {{ 'word.save' | translate }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </li>
            <li
              class="width w-110"
              *ngIf="
                showGuideInfo &&
                orderDetail?.guide_info?.lock?.lock_status !== -1
              "
            >
              <!-- 密码可见： -->
              <label>
                {{ 'order.password_visible' | translate }}
              </label>
            </li>
            <li
              class="width w-310"
              *ngIf="
                showGuideInfo &&
                orderDetail?.guide_info?.lock?.lock_status !== -1
              "
            >
              <div class="row">
                <nz-form-item>
                  <nz-form-control>
                    <nz-select
                      formControlName="visible_password_time"
                      class="width w-170"
                      (ngModelChange)="visiblePasswordTimeChange()"
                    >
                      <nz-option
                        *ngFor="let opt of passwordVisibleTimeList"
                        [nzLabel]="opt.label"
                        [nzValue]="opt.value"
                      ></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </li>
            <li
              class="width w-110"
              *ngIf="showGuideInfo && orderDetail?.guide_info?.need_credential !== -1"
            >
              <!-- 身份登记： -->
              <label>
                {{ 'order.identity_registration' | translate }}
              </label>
            </li>
            <li class="width w-310" *ngIf="showGuideInfo">
              <div class="row">
                <nz-form-item>
                  <nz-form-control>
                    <nz-select
                      formControlName="need_credential"
                      class="width w-170"
                      [nzDropdownMatchSelectWidth]="false"
                      (ngModelChange)="identityRegistrationChange()"
                    >
                      <nz-option
                        [nzLabel]="'house.need_register_and_check' | translate"
                        [nzValue]="1"
                      ></nz-option>
                      <nz-option
                        [nzLabel]="
                          'house.need_register_and_no_check' | translate
                        "
                        [nzValue]="2"
                      ></nz-option>
                      <nz-option
                        [nzLabel]="'word.no' | translate"
                        [nzValue]="0"
                      ></nz-option>
                    </nz-select>
                    <!-- 证件数为0时，显示‘上传’，>0时未审核显示‘查看’，已审核显示‘已审核’ -->
                    <span *ngIf="orderDetail?.guide_info?.image_count === 0">
                      <nz-upload
                        *ngIf="listOfImage?.length < maxSize"
                        nzAction="/api/upload/image"
                        [nzShowUploadList]="false"
                        [nzBeforeUpload]="beforeUpload"
                        [nzAccept]="'image'"
                        (nzChange)="handleImageChange($event)"
                      >
                        <span class="operating">
                          <!-- 上传 -->
                          {{ 'house.orderdetail.upload' | translate }}
                        </span>
                      </nz-upload>
                    </span>

                    <span
                      *ngIf="orderDetail?.guide_info?.image_count > 0"
                      (click)="
                        checkCredential(
                          orderDetail?.guide_info?.human_auditing_status
                        )
                      "
                    >
                      <span
                        class="operating"
                        *ngIf="
                          orderDetail?.guide_info?.human_auditing_status === 2
                        "
                      >
                        {{ 'reservation.detail.audit.checked' | translate }}
                      </span>
                      <span
                        class="operating"
                        *ngIf="
                          orderDetail?.guide_info?.human_auditing_status !== 2
                        "
                      >
                        <!-- 查看 -->
                        {{ 'house.orderdetail.view' | translate }}
                      </span>
                    </span>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </li>

            <ng-container *ngIf="!isInternational && orderDetail?.guide_info?.deposit">
              <li class="width w-110">
                <label>
                  {{ "reservation.detail.deposit.item.title" | translate }}
                  <!-- 押金 -->
                </label>
              </li>
              <li class="width w-310">

                <div class="row">
                  <host-widget-deposit
                    [depositDetail]="orderDetail?.guide_info?.deposit"
                    [reservationCode]="orderDetail?.code"
                    (onSuccess)="refreshModal.emit(true)"></host-widget-deposit>
                </div>
              </li>；
            </ng-container>


            <li class="width w-110">
              <label>
                {{ "reservation.detail.automation.item.title" | translate }}
                <!-- 自动化 -->
              </label>
            </li>
            <li class="width w-310">
              <div class="row">
                <nz-select class="width w-170" [(ngModel)]="automation" (ngModelChange)="onAutomationChange()" [ngModelOptions]="{standalone: true}">
                  <nz-option
                    *ngFor="let v of [0, 1, 2]"
                    [nzLabel]="('reservation.detail.automation.option.op_' + v) | translate"
                    [nzValue]="v"></nz-option>
                  <!-- <nz-option nzLabel="停止入住触发" [nzValue]="1"></nz-option>
                  <nz-option nzLabel="停止退房触发" [nzValue]="2"></nz-option> -->
                </nz-select>
                <i nz-icon nzType="question-circle" nzTheme="outline" style="margin-left: 10px;"
                  nz-popover
                  [nzPopoverTitle]="null"
                  [nzPopoverContent]="autoTip"></i>
              </div>

              <ng-template #autoTip>
                <div class="auto-tip-container">
                  <div
                    *ngFor="let v of [1, 2, 3]"
                    class="auto-tip-item">
                    <p style="color: #000">
                      {{ ("reservation.detail.automation.tip.title_" + v) | translate }}
                    </p>
                    <p>
                      {{ "reservation.detail.automation.tip.desc_" + v | translate }}
                      <!-- 选择后，将不再根据自动化规则触发“入住前、入住后”相关事件。 -->
                    </p>
                  </div>
                  <!-- <br>
                  <div class="auto-tip-item">
                    <p style="color: #000">停止退房触发</p>
                    <p>选择后，将不再根据自动化规则触发“退房前、退房后”相关事件。</p>
                  </div>
                  <br>
                  <div class="auto-tip-item">
                    <p style="color: #000">正常</p>
                    <p>正常触发。</p>
                  </div> -->
                </div>
              </ng-template>
            </li>
          </ul>

          <ng-template #addOnCheckInTemplate>
            <div class="edit-time-result">
              <div class="ok" (click)="confirmEditInAndOut('checkin', checkinPicker.value)">
                {{ 'word.save' | translate }}
              </div>
              <div (click)="cancelEditIn()">
                {{ 'word.cancel' | translate }}
              </div>
            </div>
          </ng-template>
          <ng-template #addOnCheckOutTemplate>
            <div class="edit-time-result">
              <div class="ok" (click)="confirmEditInAndOut('checkout', checkoutPicker.value)">
                {{ 'word.save' | translate }}
              </div>
              <div (click)="cancelEditOut()">
                {{ 'word.cancel' | translate }}
              </div>
            </div>
          </ng-template>

<!--          备注-->
          <host-widget-remark
            [reservationCode]="orderDetail?.code"
            [note]="orderDetail?.note"
            (onSuccess)="refreshModal.emit(true)"></host-widget-remark>

          <!-- 备注 -->
<!--          <div class="form-title">-->
<!--            <h1>{{ 'word.remarks' | translate }}</h1>-->
<!--            <div-->
<!--              class="edit"-->
<!--              (click)="editOrderRemarks()"-->
<!--              *ngIf="showOrderRemarks && !orderDetail?.note"-->
<!--            >-->
<!--              {{ 'word.add_remark' | translate }}-->
<!--            </div>-->
<!--            <div-->
<!--              class="edit"-->
<!--              (click)="editOrderRemarks()"-->
<!--              *ngIf="showOrderRemarks && orderDetail?.note"-->
<!--            >-->
<!--              {{ 'word.modify' | translate }}-->
<!--            </div>-->
<!--            <div class="edit-result" *ngIf="!showOrderRemarks">-->
<!--              <div (click)="cancelEditOrderRemarks()">-->
<!--                {{ 'word.cancel' | translate }}-->
<!--              </div>-->
<!--              <div (click)="confirmEditOrderRemarks()">-->
<!--                {{ 'word.save' | translate }}-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div *ngIf="orderDetail?.note">-->
<!--            <ul>-->
<!--              <li class="width w-110 align-top">-->
<!--                <label>-->
<!--                  {{ 'order.remarks_content' | translate }}-->
<!--                </label>-->
<!--              </li>-->
<!--              <li-->
<!--                [ngClass]="{-->
<!--                  'w-310': pageType === 'sidebar',-->
<!--                  'w-730': pageType === 'modal'-->
<!--                }"-->
<!--              >-->
<!--                <div *ngIf="showOrderRemarks">-->
<!--                  <span style="word-break: break-word">{{-->
<!--                    orderDetail?.note-->
<!--                  }}</span>-->
<!--                </div>-->
<!--                <div *ngIf="!showOrderRemarks">-->
<!--                  <nz-form-item>-->
<!--                    <nz-form-control style="padding-top: 13px">-->
<!--                      <textarea-->
<!--                        [style.width]="-->
<!--                          pageType === 'sidebar' ? '310px' : '730px'-->
<!--                        "-->
<!--                        rows="3"-->
<!--                        type="text"-->
<!--                        nz-input-->
<!--                        formControlName="reservation_note"-->
<!--                        placeholder="{{-->
<!--                          'placeholder.order_remarks' | translate-->
<!--                        }}"-->
<!--                      ></textarea>-->
<!--                    </nz-form-control>-->
<!--                  </nz-form-item>-->
<!--                </div>-->
<!--              </li>-->
<!--            </ul>-->
<!--          </div>-->
<!--          <div *ngIf="!orderDetail?.note && !showOrderRemarks">-->
<!--            <ul>-->
<!--              <li class="width w-110">-->
<!--                <label>-->
<!--                  {{ 'order.remarks_content' | translate }}-->
<!--                </label>-->
<!--              </li>-->
<!--              <li-->
<!--                [ngClass]="{-->
<!--                  'w-310': pageType === 'sidebar',-->
<!--                  'w-730': pageType === 'modal'-->
<!--                }"-->
<!--              >-->
<!--                <nz-form-item>-->
<!--                  <nz-form-control style="padding-top: 13px">-->
<!--                    <textarea-->
<!--                      [style.width]="pageType === 'sidebar' ? '310px' : '730px'"-->
<!--                      rows="3"-->
<!--                      nz-input-->
<!--                      formControlName="reservation_note"-->
<!--                      placeholder="{{-->
<!--                        'placeholder.order_remarks' | translate-->
<!--                      }}"-->
<!--                    ></textarea>-->
<!--                  </nz-form-control>-->
<!--                </nz-form-item>-->
<!--              </li>-->
<!--            </ul>-->
<!--          </div>-->

          <!-- 其他 -->
          <div class="form-title">
            <h1>{{ 'word.other' | translate }}</h1>
            <div
              class="edit"
              *ngIf="orderDetail?.thirdparty_type !== 5"
              hostThrottleClick
              (throttleClick)="RereadOrder()"
            >
              <!-- 重新读取 -->
              {{ 'order.read_data_again' | translate }}
            </div>
          </div>
          <ul class="show-ul">
            <!-- 订单号 -->
            <li class="width w-110 align-top">
              <!-- 订单号： -->
              <label>{{ 'order.order_code' | translate }}</label>
            </li>
            <li class="width w-310">
              <div class="order-code">
                <span style="max-width: 200px; word-break: break-all">
                  {{ orderDetail?.reservation_order?.code }}
                </span>
                <div
                  class="order-copy"
                  hostClipboard
                  [clipboardData]="orderDetail?.reservation_order?.code">
                  <!-- 复制 -->
                  {{ 'word.copy' | translate }}
                </div>
                <div
                  class="checkin-copy"
                  style="margin-left: 10px"
                  (click)="
                    toLog(
                      'reservation_order',
                      orderDetail?.reservation_order?.code
                    )
                  "
                >
                  <!-- 日志 -->
                  {{ 'system.log' | translate }}
                </div>
              </div>
            </li>
            <!-- 下单时间 -->
            <li class="width w-110">
              <label>
                {{ 'order.booked_time_time' | translate }}
              </label>
            </li>
            <li class="width w-310">
              <span *ngIf="orderDetail?.booked_time">
                {{ orderDetail?.booked_time | dateformat }}
              </span>
              <span *ngIf="!orderDetail?.booked_time">
                {{ 'order.can_not_get_book_time' | translate }}
              </span>
            </li>
            <!-- 取消时间 -->
            <li
              class="width w-110"
              *ngIf="orderDetail?.reservation_cancel_time"
            >
              <label>
                {{ 'order.cancel_time_time' | translate }}
              </label>
            </li>
            <li
              class="width w-310"
              *ngIf="orderDetail?.reservation_cancel_time"
            >
              <span>
                {{ orderDetail?.reservation_cancel_time?.cancel_time }}
              </span>
            </li>
            <!-- 预订房源 -->
            <li class="width w-110" *ngIf="orderDetail?.thirdparty_type !== 5">
              <label>
                {{ 'order.order_channel_house' | translate }}
              </label>
            </li>
            <li class="width w-310" *ngIf="orderDetail?.thirdparty_type !== 5">
              <div class="order-code">
                <span
                  class="origin-title"
                  [attr.title]="
                    orderDetail?.origin_house_title
                      ? orderDetail?.origin_house_title
                      : orderDetail?.house_title
                  "
                >
                  {{
                    orderDetail?.origin_house_title
                      ? orderDetail?.origin_house_title
                      : orderDetail?.house_title
                  }}
                </span>
                <a
                  class="glance"
                  [href]="orderDetail?.origin_house_link"
                  target="_blank"
                >
                  <!-- 浏览 -->
                  {{ 'order.scan' | translate }}
                </a>
              </div>
            </li>

            <ng-container *ngIf="orderDetail?.thirdparty_username">
              <li class="width w-110">
                <label>
                  {{ "reservation.detail.account.item.title" | translate }}
                  <!-- 渠道账号: -->
                </label>
              </li>
              <li class="width w-310">
                <span>{{ orderDetail?.thirdparty_username }}</span>
              </li>
            </ng-container>

            <li class="width w-110">
              <label>
                {{ "reservation.detail.creator.item.title" | translate }}
                <!-- 创建人: -->
              </label>
            </li>
            <li class="width w-310">
              <ng-container *ngIf="!isSubaccount else creatorText">
                <nz-select
                  [nzPlaceHolder]="'reservation.detail.creator.item.placeholder' | translate" class="w-170 width"
                  [(ngModel)]="currentCreatorId"
                  [ngModelOptions]="{standalone: true}"
                  (ngModelChange)="requestSetCreator()">
                  <nz-option
                    *ngFor="let opt of listOfSubaccount"
                    [nzValue]="opt.operator_id"
                    [nzLabel]="opt.creator_name"></nz-option>
                </nz-select>
              </ng-container>
              <ng-template #creatorText>
                <span>{{ orderDetail?.creator_name }}</span>
              </ng-template>
            </li>
          </ul>

          <div
            class="form-title"
            *ngIf="pageType === 'sidebar' && orderDetail?.thirdparty_type === 5"
          >
            <div class="cancel-order" (click)="cancelOrder()">
              <!-- 取消此单 -->
              {{ 'order.cancel_order' | translate }}
            </div>
          </div>
        </form>
      </div>
    </div>
  </nz-spin>

  <!-- 订单详情底部按钮 -->
  <div class="footer">
    <ng-container
      *ngIf="orderDetail?.out_status !== 'cancelled'; else cancelledOrder"
    >
      <div class="footer-left">
        <div
          class="button"
          *ngIf="pageType !== 'sidebar' && orderDetail?.thirdparty_type === 5"
        >
          <button nz-button nzType="default" (click)="cancelOrder()">
            <!-- 取消此单 -->
            {{ 'order.cancel_order' | translate }}
          </button>
        </div>
        <div class="button" *ngIf="pageType === 'sidebar'">
          <button
            nz-button
            nz-dropdown
            [nzDropdownMenu]="createHourOrderMenu"
            [nzPlacement]="'topCenter'"
          >
            <!-- 小时单 -->
            {{ 'order.detail_footer_add_hour_order' | translate }}
            <i nz-icon nzType="caret-down" nzTheme="outline"></i>
          </button>
        </div>
      </div>
      <div
        *ngIf="orderDetail?.out_status === 'wait_accept'"
        class="footer-right"
      >
        <div class="button">
          <button
            nz-button
            nzType="primary"
            [nzLoading]="acceptLoading"
            (click)="acceptOrder()"
          >
            <!-- 接受 -->
            {{ 'order.accept_order' | translate }}
          </button>
        </div>
        <div class="button">
          <button nz-button [nzLoading]="refuseLoading" (click)="refuseOrder()">
            <!-- 拒绝 -->
            {{ 'order.refuse_order' | translate }}
          </button>
        </div>
        <div *ngIf="pageType === 'sidebar'" class="button">
          <button nz-button nzType="default" (click)="close()">
            {{ 'word.close' | translate }}
          </button>
        </div>
      </div>
      <div
        *ngIf="orderDetail?.out_status !== 'wait_accept'"
        class="footer-right"
      >
        <div *ngIf="orderDetail?.out_status === 'wait_stay'">
          <div class="button">
            <button
              *ngIf="orderDetail?.singleOrMass === 'mass'"
              nz-button
              nz-dropdown
              nzType="primary"
              [nzDropdownMenu]="checkInMenu"
              [nzPlacement]="'topCenter'"
            >
              <!-- 入住 -->
              {{ 'order.check_in' | translate }}
              <i nz-icon nzType="caret-down" nzTheme="outline"></i>
            </button>
            <button
              *ngIf="orderDetail?.singleOrMass === 'single'"
              nz-button
              nzType="primary"
              (click)="revocation(1, 'single')"
            >
              {{ 'order.check_in' | translate }}
            </button>
          </div>
        </div>
        <div *ngIf="orderDetail?.out_status === 'staying'">
          <div class="button">
            <button
              *ngIf="orderDetail?.singleOrMass === 'mass'"
              nz-button
              nz-dropdown
              nzType="primary"
              [nzDropdownMenu]="checkOutMenu"
              [nzPlacement]="'topCenter'"
            >
              <!-- 退房 -->
              {{ 'order.check_out' | translate }}
              <i nz-icon nzType="caret-down" nzTheme="outline"></i>
            </button>
            <button
              *ngIf="orderDetail?.singleOrMass === 'single'"
              nz-button
              nzType="primary"
              (click)="revocation(1, 'single')"
            >
              {{ 'order.check_out' | translate }}
            </button>
          </div>
        </div>
        <div class="button">
          <button
            *ngIf="orderDetail?.singleOrMass === 'mass'"
            nz-button
            nz-dropdown
            [nzDropdownMenu]="continueStayMenu"
            [nzPlacement]="'topCenter'"
          >
            <!-- 续住 -->
            {{ 'order.continue_stay' | translate }}
            <i nz-icon nzType="caret-down" nzTheme="outline"></i>
          </button>
          <button
            *ngIf="orderDetail?.singleOrMass === 'single'"
            nz-button
            nzType="default"
            (click)="continueStay('single')"
          >
            {{ 'order.continue_stay' | translate }}
          </button>
        </div>
        <div *ngIf="pageType === 'sidebar'" class="button">
          <button nz-button nzType="default" (click)="close()">
            {{ 'word.close' | translate }}
          </button>
        </div>
      </div>
    </ng-container>
    <ng-template #cancelledOrder>
      <div class="footer-right">
        <div *ngIf="pageType === 'sidebar'" class="button">
          <button nz-button nzType="default" (click)="close()">
            {{ 'word.close' | translate }}
          </button>
        </div>
      </div>
    </ng-template>
  </div>

  <nz-dropdown-menu #checkInMenu="nzDropdownMenu">
    <ul nz-menu class="menu-list">
      <li nz-menu-item (click)="revocation(1, 'single')">
        <!-- 入住 -->
        {{ 'order.check_in' | translate }}
      </li>
      <li nz-menu-item (click)="revocation(1, 'mass')">
        <!-- 批量入住 -->
        {{ 'order.multi_check_in' | translate }}
      </li>
    </ul>
  </nz-dropdown-menu>

  <nz-dropdown-menu #checkOutMenu="nzDropdownMenu">
    <ul nz-menu class="menu-list">
      <li nz-menu-item (click)="revocation(1, 'single')">
        <!-- 退房 -->
        {{ 'order.check_out' | translate }}
      </li>
      <li nz-menu-item (click)="revocation(1, 'mass')">
        <!-- 批量退房 -->
        {{ 'order.multi_check_out' | translate }}
      </li>
    </ul>
  </nz-dropdown-menu>

  <nz-dropdown-menu #continueStayMenu="nzDropdownMenu">
    <ul nz-menu class="menu-list">
      <li nz-menu-item (click)="continueStay('single')">
        <!-- 续住 -->
        {{ 'order.continue_stay' | translate }}
      </li>
      <li nz-menu-item (click)="continueStay('mass')">
        <!-- 批量续住 -->
        {{ 'order.multi_continue_stay' | translate }}
      </li>
    </ul>
  </nz-dropdown-menu>

  <nz-dropdown-menu #createHourOrderMenu="nzDropdownMenu">
    <ul nz-menu class="menu-list">
      <li nz-menu-item (click)="createNewHourOrder(orderDetail?.check_in)">
        {{
          'order.create_hour_order_in_someday'
            | translate
              : {
                  date: orderDetail?.check_in | dateformat: ['MD']
                }
        }}
      </li>
      <li
        nz-menu-item
        (click)="createNewHourOrder(orderDetail?.check_out)"
        *ngIf="!orderDetail?.is_hour_reservation"
      >
        {{
          'order.create_hour_order_in_someday'
            | translate
              : {
                  date: orderDetail?.check_out | dateformat: ['MD']
                }
        }}
      </li>
    </ul>
  </nz-dropdown-menu>

</div>

<!-- 订单中展示小时单信息 -->
<ng-template #hourOrderInfoInReservation let-orderDetail>
  <div class="hour-order-items">
    <div
      *ngIf="orderDetail?.checkin_last_hour_reservation"
      class="hour-order-item"
    >
      <div
        [ngClass]="{
          'confilct-hour-order':
            orderDetail?.checkin_last_hour_reservation?.has_conflict,
          'normal-hour-order': !orderDetail?.checkin_last_hour_reservation
            ?.has_conflict
        }"
        nz-popover
        [nzPopoverContent]="checkinHourOrderInfo"
        nzPopoverPlacement="topLeft"
        (click)="
          JumptoHourDetail(
            orderDetail?.checkin_last_hour_reservation?.reservation_code
          )
        "
      >
        <img src="/assets/house/hour_order_in_reservations.png" />
        <p>{{ orderDetail?.checkin_last_hour_reservation?.text }}</p>
      </div>
      <ng-template #checkinHourOrderInfo>
        <div class="hour-order-info">
          <p class="name">
            {{ orderDetail?.checkin_last_hour_reservation?.client?.name }}
          </p>
          <p class="time">
            {{
              'order.hour_order_time_range'
                | translate
                  : {
                      time1:
                        orderDetail?.checkin_last_hour_reservation?.check_in +
                          ' ' +
                          orderDetail?.checkin_last_hour_reservation
                            ?.hour_reservation_start_time
                        | dateformat: [null, 'hm'],
                      time2:
                        orderDetail?.checkin_last_hour_reservation?.check_in +
                          ' ' +
                          orderDetail?.checkin_last_hour_reservation
                            ?.hour_reservation_end_time
                        | dateformat: [null, 'hm']
                    }
            }}
          </p>
        </div>
      </ng-template>
    </div>
    <div
      *ngIf="orderDetail?.checkout_first_hour_reservation"
      class="hour-order-item"
    >
      <div
        [ngClass]="{
          'confilct-hour-order':
            orderDetail?.checkout_first_hour_reservation?.has_conflict,
          'normal-hour-order': !orderDetail?.checkout_first_hour_reservation
            ?.has_conflict
        }"
        nz-popover
        [nzPopoverContent]="checkoutHourOrderInfo"
        nzPopoverPlacement="topLeft"
        (click)="
          JumptoHourDetail(
            orderDetail?.checkout_first_hour_reservation?.reservation_code
          )
        "
      >
        <img src="/assets/house/hour_order_in_reservations.png" />
        <p>{{ orderDetail?.checkout_first_hour_reservation?.text }}</p>
      </div>
      <ng-template #checkoutHourOrderInfo>
        <div class="hour-order-info">
          <p class="name">
            {{ orderDetail?.checkout_first_hour_reservation?.client?.name }}
          </p>
          <p class="time">
            {{
              'order.hour_order_time_range'
                | translate
                  : {
                      time1:
                        orderDetail?.checkout_first_hour_reservation?.check_in +
                          ' ' +
                          orderDetail?.checkout_first_hour_reservation
                            ?.hour_reservation_start_time
                        | dateformat: [null, 'hm'],
                      time2:
                        orderDetail?.checkout_first_hour_reservation?.check_in +
                          ' ' +
                          orderDetail?.checkout_first_hour_reservation
                            ?.hour_reservation_end_time
                        | dateformat: [null, 'hm']
                    }
            }}
          </p>
        </div>
      </ng-template>
    </div>
  </div>
</ng-template>
